import { Text } from '$components'
import { CalendarIcon } from '$components'

export function NoAppointmentHistoryEmptyState() {
  return (
    <div className="w-full p-stack-hero bg-surface-muted rounded-card flex flex-col items-center justify-center text-center">
      <CalendarIcon className="size-12 text-fg-link mb-stack-roomy" />

      <Text
        type="h3"
        className="mb-stack-roomy text-fg"
      >
        No appointment history
      </Text>

      <Text
        type="s"
        className="text-fg-subtle max-w-prose-sm"
      >
        This client doesn&apos;t have any other appointments yet.
      </Text>
    </div>
  )
}
